var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Type_03_ContinuousImprovement_Selected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_03_ContinuousImprovement_Selected",
    clipPath: "url(#clip-Icons_Type_03_ContinuousImprovement_Selected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_03_Continuous_Improvement_Selected-2",
    "data-name": "Icons_Type_03_Continuous Improvement_Selected-2",
    transform: "translate(132.584 182.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(229.25 128.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 771.205,
    cy: 771.205,
    r: 771.205,
    fill: "#eaeaea"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(11.169 12.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M798.663,980.14H776.686C342.134,968.153-.513,604.527,11.475,170.974c1-22.976,2-45.953,4.995-68.929,2-13.986,13.986-22.976,27.971-21.977,13.986,2,23.975,13.986,21.977,27.971-2,20.978-4,42.956-4.995,64.933C49.436,579.553,371.1,920.2,777.685,931.191c310.68,8.991,596.385-179.815,709.269-470.515,4.995-12.987,19.979-18.98,31.967-13.986,12.987,4.995,18.98,18.98,13.985,31.967C1415.028,780.346,1122.33,980.14,798.663,980.14Z",
    transform: "translate(-11.169 595.562)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1491.349,913.764h-3c-13.985-2-23.975-13.986-21.977-27.971,2-20.978,4-42.956,4.995-63.934,5.994-196.8-65.932-384.6-200.793-527.456C1134.716,150.551,951.9,68.635,755.108,62.641,461.41,54.65,190.69,221.478,65.818,487.2a24.349,24.349,0,0,1-32.966,11.988,24.349,24.349,0,0,1-11.988-32.966C153.728,181.519,443.429,3.7,757.106,12.693c209.784,5.994,405.582,93.9,550.433,246.746s220.772,352.637,214.779,563.419c-1,22.976-2,45.953-4.995,68.929C1514.325,903.774,1504.336,913.764,1491.349,913.764Z",
    transform: "translate(53.364 -12.367)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(37.741 177.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 308.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M995.462,649.993c-11.988,8.991-17.981,32.966-29.969,44.954-13.986,13.986-29.969,24.974-47.951,33.965-35.963,19.979-75.922,32.966-113.883,45.953-87.909,28.97-237.755,34.964-306.684-38.96-53.944-57.94-78.919-152.842-74.923-230.762,2-34.964-6.993-99.9,61.936-65.932,19.979,9.99,37.961,22.976,57.94,33.965,39.959,21.977,125.87,45.953,140.855,15.983,9.99-21.977-28.97-52.945-45.953-78.919C566.9,306.347,524.948,193.464,464.01,88.572c-4.995-8.991-10.989-18.98-21.977-23.975-7.992-4-15.983-4-22.976-3-137.858,9.99-269.722,31.967-384.6,73.924-6.993,2-12.987,4.995-16.983,9.99-7.992,11.988,4,33.965,21.977,50.948s40.958,27.971,62.935,39.959c51.946,26.972,95.9,37.961,101.895,79.918,4.995,31.967-14.985,61.936-15.983,92.9C182.3,521.126,225.256,645,307.172,757.882c18.98,25.973,47.951,63.934,93.9,98.9,36.962,28.97,79.918,52.945,131.864,72.925,105.891,41.957,213.78,58.939,312.678,48.95A551.237,551.237,0,0,0,962.5,954.679c47.951-15.983,90.906-39.959,136.859-57.94,44.954-16.982,73.924-44.954,105.891-81.915a3.67,3.67,0,0,0,1-3,2.149,2.149,0,0,0-2-2c-35.963-19.979-65.932-55.942-96.9-81.915-18.98-15.983-37.961-32.966-56.941-48.95-8.991-6.993-40.958-38.96-54.943-28.97Z",
    transform: "translate(-14.947 -61.044)",
    fill: "#ff6912"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(479.024 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M944,448.532c-20.978-95.9-71.926-179.815-150.845-248.744C731.218,144.846,654.3,100.891,564.39,69.923,309.652-16.988,180.785,49.943,72.9,159.83,65.9,166.823,57.912,176.813,66.9,190.8c5.994,9.99,17.981,18.98,28.97,25.973,57.94,41.957,111.885,87.909,159.835,136.859,4.995,4.995,9.99,9.99,15.983,11.988s9.99,0,12.987-3c45.953-32.966,52.945-92.9,107.889-119.876,50.947-24.974,123.872-16.982,204.789,10.989,31.967,10.989,57.94,23.975,71.926,35.963,17.981,15.983,33.965,47.951,42.956,86.91,17.982,78.919,4,130.865-30.968,180.814-3,4-5.994,7.992-10.989,9.99-6.993,2-15.984-1-24.974-3-28.97-8.991-100.9-51.946-121.874-49.948-31.967,3-13.986,64.933-7.992,91.905,18.98,82.915,73.924,174.82,127.868,262.729,3,4,5.994,8.991,9.99,11.988,6.993,4.995,13.986,5.994,20.978,5.994,96.9,6.993,185.809,0,262.729-19.979,16.982-4.995,170.824-51.946,128.867-78.919-49.949-33.965-100.9-66.931-151.843-100.9C955.986,622.353,965.976,547.431,944,448.532Z",
    transform: "translate(-62.899 -30.115)",
    fill: "#ff6912"
  }))))))));
};
export default __webpack_public_path__ + "static/media/Icons_Type_03_ContinuousImprovement_Selected.5f2308ef.svg";
export { SvgComponent as ReactComponent };